<template>
    <div class="terms-and-conditions__info">
        <i18n path="registration.terms">
            <StaticLink
                place="terms"
                path="terms-and-conditions"
                target="_blank"
                class="action-text"
            >
                {{ $t('Superbet terms and conditions') | capitalize }}
            </StaticLink>
            <StaticLink
                place="statement"
                path="declaratia-de-confidentialitate"
                target="_blank"
                class="action-text"
            >
                {{ $t('Superbet Confidentiality Statement') }}
            </StaticLink>
        </i18n>
    </div>
</template>

<script>
    import Vue from 'vue';
    import StaticLink from '@shared/components/StaticLink.vue';

    export default Vue.component('TermsAndConditions', {
        components: {
            StaticLink,
        },
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/TermsAndConditions.vue